export enum searchTypeEnum {
	COMPANY_NAME = 'name',
	CONTACT = 'contact_name',
	OPEN_ACCOUNT = 'accountId',
	HYPER_ACCOUNT = 'hyperAccountNumber',
	CC_ACCOUNT = 'ccId',
}
